import { makeAutoObservable, autorun, runInAction, computed, action, observable } from "mobx"
import { Cache } from './Cache';
import { createStorage } from './Storage'
import { Config } from './config'
import {fetch_ as fetch} from './fetch'
import EditorConfig from './EditorConfig'
import { environment } from '../common'

const BASE_API_ROUTE = "/api/v1"
export class Connection {
    status = false
    token = ""
    // api_path = "/app/v1"
    base_path = ""
    api_path = ""
    cache = {}
    routes = []
    menu_tree = []
    user_context = {}
    editor_config = {}
    router = {'routes':[],'navigate':false}
    superset = {}

    get visible_routes(){
        
        if(!this.routes){
            return []
        }
        return this.routes.filter(function(route){return route.visible_menu === true})
    }
    constructor(notifications) {
        makeAutoObservable(this, {
            loadRoutes:action,
            setRouter:action,
            setEditorConfig:action,
            visible_routes:computed,
            routes:observable,
            menu_tree:observable,
            editor_config:observable,
            api_path:observable,
            base_path:observable,
            setApiPath:action,
            setSessionStatus:action,
            status:observable,
            initialize:action,
            user_context:observable,
            setUserContext:action
        })
        
        this.initialize(notifications)

    }
    initialize(notifications){
        this.config = Config()
        this.status = undefined
        this.token = ""
        this.api_path = this.config.api_path ? this.config.api_path:false
        this.auth_proxy = this.config.auth_proxy ? this.config.auth_proxy:false
        this.routes = []
        this.router = {'routes':[],'navigate':false}
        this.cache = new Cache()
        this.storage = createStorage()
        this.notifications = notifications

        this.setUserContext({})
        this.getSessionFromStorage()
    }
    async getSessionFromStorage(){
        let session_info = await this.storage.getItem('kalenis_session')
        if (session_info) {
            
            
            this.setSession(JSON.parse(session_info))


          }
        else{
            this.setSessionStatus(false)
        }

    }

    async saveSessionToStorage(session){
        let stored_session = await this.storage.getItem('kalenis_session')

        if(!stored_session){
            await this.storage.setItem('kalenis_session', JSON.stringify(session))
        }
    }

    setSessionStatus(value){
        this.status = value;
    }
        

    getPath(path) {
        
        if(!this.api_path){
            return false
        }
        return this.api_path.concat(path)

    }
    getRouteById(id){
        
        return this.router.routes.find(route => route.id === id)
    }
    setRouter(router){
        
        this.router = router;
    }
    createUrl(params) {
        var query = "?"
       
        Object.keys(params).map(function (field) {// eslint-disable-line
            
            if(field === "search"){
    
                let current_search = params[field]
                
                current_search.forEach(function(domain){
                    
                    const field = domain[0]
                    const operator = domain[1]
                    let value = domain[2]
                    if(value !== "" && value !== undefined){
                        if(operator){
                            
                            if(Array.isArray(value)){
                                value = value.toString()
                                value = '['.concat(value).concat(']')
                            }
    
                        }
                        value = operator.concat(";").concat(value)
                    }
                    query = query.concat(field).concat('=').concat(value).concat('&')
                    
                })
                
    
            }
            else if (field === 'action_params'){
                let action_params = params[field]
                
                if(action_params.length){
                    query = query.concat('_ap=')
                    action_params.forEach(function(domain){
                    
                        const field = domain[0]
                        const operator = domain[1]
                        let value = domain[2]
                        if(value !== "" && value !== undefined){
                            if(operator){
                                
                                if(Array.isArray(value)){
                                    value = value.toString()
                                    value = '['.concat(value).concat(']')
                                }
        
                            }
                            value = operator.concat(";").concat(value)
                        }
                        query = query.concat(field).concat(';').concat(value).concat('&')
                        
                    })
                }
                
                
            }
    
            else if(field === "order"){
               
                if(params[field].length){
                    query = query.concat('_order').concat("=").concat(params[field].toString()).concat('&')
                }
                
            }
            else if(field === "action_id"){
                if(params[field]){
                    query = query.concat('_action_id').concat("=").concat(params[field]).concat('&')
                }
            }
      
      
        })
      
       console.log("QUERY IN CREATE URL")
       console.log(query)
      
        return query
      }

    getHeaders() {
        let headers;
        if (this.status && this.token) {
            headers = {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.token,
                'pragma':'no-cache',
                'cache-control':'no-cache'

            }
        }
        else {
            headers = {
                'Accept': 'application/json',
                'Content-Type': 'application/json',

            }
        }

        return headers;
    }


    createQuery(params) {
        var search = "?"

        Object.keys(params).map(function (field) {// eslint-disable-line

            if (params[field] !== "" && params[field] !== undefined) {


                var field_value = params[field]
                
                if (field_value instanceof Array) {
                    // field_value = field_value.join(';')
                    field_value = JSON.stringify(field_value)
                    field_value = field_value.replace('null','None')
                }

                if (field_value instanceof Object) {
                    field_value = JSON.stringify(field_value)
                    field_value = field_value.replace('null','None')
                }
                
               


                search = search.concat(field).concat('=').concat(field_value).concat('&')


            }


        })



        return search
    }

    async handleNativeBlobResponse(response){
        
        res = {}
        
        res['mimetype'] = response.headers.get('content-type')
        res['data'] = await response.blob()
        return res
    }


    async Post(body, path, headers, raw_response) {
        var body_req = JSON.stringify(body)
        let response = ""

        try {
            response = await fetch(path, {
                method: 'POST',
                headers: headers,
                mode: 'cors',
                body: body_req,
            })

        } catch (e) {
            
            // I/ReactNativeJS(28769): { [TypeError: Network request failed] line: 137, column: 8199, sourceURL: 'index.android.bundle' }
            
            return { 'error': 'retry' }
        }

        



        let res;

        if (!raw_response && response.status === 401) {
            this.removeLocalSession()
            return false
        }
        if (!raw_response && response.status === 400) {
            res = await response.json()
            this.notifications.addSnack(
                { message: res.error, level: 'error', persistant:false }
            )
            
            return false

        }

        if (!raw_response && response.status !== 200) {

            res = await response.text()
            // TODO: Sentry
            this.notifications.addSnack(
                { message: "Algo ha salido mal, por favor intentelo nuevamente mas tarde.", level: 'error', persistant:false }
            )
            return false
            // return false
        }


        if (raw_response) {
            res = response
        }
        else {
            res = await response.json();
        }

        return res;
    }

    async Get(args, path, headers, raw_response, blob, cache_write, abortController) {

        // var body_req = JSON.stringify(body)
        let fullPath = args ? path.concat(this.createQuery(args)) : path
        

        const cached = this.cache.get(fullPath)
        if (cached) {
            
            return cached
        }

        let response = await fetch(fullPath, {
            signal: abortController ? abortController.signal : false,
            method: 'GET',
            headers: headers,
            mode: 'cors',

        })



        if (response.status === 401) {
            this.removeLocalSession()
            return false
        }

        let res;

        if (!raw_response && response.status === 404) {
            
            // res = await response.text()
            // alert(res)
            return false
            // return false
        }
        else if(response.status === 400){
            res = await response.json()
            this.notifications.addSnack(
                { message: res.error, level: 'error', persistant:false }
            )
            
            

            return false
        }





        if (blob) {
           
            if(environment() === 'native'){
                res = await this.handleNativeBlobResponse(response)
            }
            else{
                res = await response.blob()
            }

        }
        
        else {
            res = await response.json()
        }

        if (cache_write) {
            runInAction(() => {
                this.cache.set(fullPath, res)
              })
            
        }




        return res;

    }

    async removeLocalSession(){
        return await this.storage.removeItem('kalenis_session')
    }

    setSession(session){
        
        if(!session){
            return
        }
        
        this.token = session.token
        if(session.superset){
            this.superset = session.superset
        }
        this.status = true
        if(session.url && this.auth_proxy){
            this.setApiPath(session.url)
        }
        this.saveSessionToStorage(session)
        
        this.loadUserContext()
        this.loadRoutes()
        this.setEditorConfig()
        
    }

    async loadUserContext(){
        const abortController = new AbortController();
        let user_context = await this.dispatch('GET', '/user/context', '', false, true, false, abortController)
        console.log("Setting user context")
        
        this.setUserContext(user_context)
        
    }
    setUserContext(context){
        this.user_context = context
    }
    setEditorConfig(){
        this.editor_config = new EditorConfig(this)
    }
    
    async loadRoutes(){
        const abortController = new AbortController();
        let routes = await this.dispatch('GET', '/user/menu', '', false, false, false, abortController)
        runInAction(() => {
            this.routes = routes.routes
            this.menu_tree = routes.tree
          })
        
    }

    logout(){
        this.status = false
        this.token = ""
        this.removeLocalSession()
        this.initialize(this.notifications)
    }

    setApiPath(path){
        this.base_path = path;
        this.api_path = path.concat('/app/v1');
    }

    async getAvailableHosts(values){
        let headers = this.getHeaders()
        const session_path = this.config.auth_proxy.concat('/mid/v1/user/hosts')
        let hosts = await this.Get(values, session_path, headers, false)
        
        return hosts

        
    }

    async login(values){
        // if(this.auth_proxy){
        //     return await this.ProxyLogin(values) 
        // }

        let headers = this.getHeaders()
        const session_path = this.getPath("/auth/token")

        let session = await this.Post(values, session_path, headers, false)
        
        
        if(session){
            session['url'] = this.base_path
            this.setSession(session)
            
        }
        return session
    }

    async dispatch(type, path, args, raw_response, cache_write, blob, abortController) {
        let headers = this.getHeaders()
        path = path ? this.getPath(path) : ""
        
        if(!path){
            return false
        }
        switch (type) {
            case 'POST': {


                return await this.Post(args, path, headers, raw_response)
            }
            case 'GET': {

                return await this.Get(args, path, headers, raw_response, blob, cache_write, abortController)

            }

            default:
                throw new Error();
        }

    }



}